import React, { FunctionComponent } from "react";

export interface CellProps {
  headerRow?: boolean;
  filler?: boolean;
}

const Cell: FunctionComponent<CellProps> = ({
  children,
  headerRow,
  filler,
}) => {
  const classList = ["planCompare__cell"];
  if (headerRow) {
    classList.push("planCompare__cell--headerRow");
  }
  if (filler) {
    classList.push("planCompare__cell--fillerRow");
  }

  return <div className={classList.join(" ")}>{children}</div>;
};

export default Cell;
